import React, { Fragment, useState } from 'react';
import { Grid } from '@material-ui/core';

import { GQLParty } from '@jewelutions/core-crm-server-api-client-domain';

import { ErrorComponent, LoadingSpinner, DetailsList, SectionCard } from '../../../../components';
import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';

interface IProps {
  party: GQLParty;
}

const OverallSettings: React.FC<IProps> = ({ party }: IProps) => {
  const [errorComponentState, setErrorComponentState] = useState(false);

  const { data, loading, error, refetch } = GQLOperationBuilder.party.getPartyMerchantChannels({
    partyId: party.id
  });

  if (loading) return <LoadingSpinner />;

  if (error && !errorComponentState)
    return (
      <ErrorComponent
        close={setErrorComponentState}
        details={error?.stack}
        callback={refetch}
        message={error.message}
      />
    );

  const channel = GQLOperationBuilder.party.merchantChannelArrayFromResponse(data)[0];

  return (
    <Fragment>
      <Grid item style={{ marginTop: '8px' }}>
        <SectionCard title="Sales Channel">
          <DetailsList
            list={[
              {
                primary: 'Active',
                secondary: channel.active + ''
              },
              {
                primary: 'Name',
                secondary: channel.name
              },
              {
                primary: 'Type',
                secondary: channel.channelType
              },
              {
                primary: 'Domain',
                secondary: channel.domain
              },
              {
                primary: 'Language',
                secondary: channel.configuration.defaultLanguage
              },
              {
                primary: 'Currency',
                secondary: channel.configuration.primaryCurrency
              },
              {
                primary: 'Weight unit',
                secondary: channel.configuration.primaryWeightUnit + ''
              }
            ]}
          />
        </SectionCard>
      </Grid>
    </Fragment>
  );
};

export default OverallSettings;
